export default "__VITE_ASSET__CDFQ4CnO__"